import { Box } from '@jfs/ui-new'
import { ButtonNew } from '../../components/AdminButton'
export interface SearchButtonProps {
  onProceedPress: () => void
  disabled: boolean
}

const SearchButton = (props: SearchButtonProps) => {
  const { onProceedPress, disabled } = props

  const onPress = () => {
    onProceedPress()
  }

  return (
    <Box marginBottom={8} w={120}>
      <ButtonNew title={'Search'} onPress={onPress} type={'primary'} height={36} disabled={disabled} />
    </Box>
  )
}

export default SearchButton
